import { format, parseISO } from "date-fns";
import { Loader2, Search, Smartphone } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSitePath } from "../context/SiteContext";
import { toast } from "sonner";
import { api, apiError, money } from "../lib/api";
import { ReservationSummary } from "../components/ReservationSummary";

export default function FindReservation() {
  const [form, setForm] = useState({ ref: "", last_name: "", email: "" });
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const sp = useSitePath();
  const payBalance = async () => {
    try {
      const { data } = await api.post(`/reservations/${res.ref}/pay-balance`, { last_name: form.last_name, email: form.email });
      navigate(sp(`/payment/${data.checkout.cid}`));
    } catch (e2) {
      toast.error(apiError(e2));
    }
  };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    setRes(null);
    try {
      setRes((await api.get("/reservations/lookup", { params: form })).data);
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="container-x max-w-4xl pt-16" data-testid="find-reservation-page">
      <p className="eyebrow">Manage booking</p>
      <h1 className="mt-2 font-serif text-5xl text-ink sm:text-6xl">Find Reservation</h1>
      <p className="mt-3 text-ink/60">Enter your booking reference, the guest's last name and the email address used to book.</p>
      <form onSubmit={submit} className="mt-8 grid gap-4 rounded-3xl border border-brand/10 bg-white p-6 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_1.3fr_auto] sm:items-end">
        <label className="field"><span className="field-label">Reference</span>
          <input required className="field-input font-mono uppercase" placeholder="ER1A2B3C" value={form.ref} onChange={(e) => setForm({ ...form, ref: e.target.value })} data-testid="find-ref-input" />
        </label>
        <label className="field"><span className="field-label">Last name</span>
          <input required className="field-input" value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} data-testid="find-last-name-input" />
        </label>
        <label className="field"><span className="field-label">Email address</span>
          <input required type="email" className="field-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="find-email-input" />
        </label>
        <button className="btn-primary" disabled={busy} data-testid="find-submit-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}Find
        </button>
      </form>
      {err && <p className="mt-6 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="find-error">{err}</p>}
      {res && (
        <div className="mt-8 animate-rise">
          <ReservationSummary res={res} />
          {res.balance > 0 && (
            <div className="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-gold/40 bg-white p-5" data-testid="balance-panel">
              <p className="text-sm text-ink">Outstanding balance <b className="font-mono" data-testid="balance-amount">{money(res.balance, res.quote.currency)}</b> due by {format(parseISO(res.balance_due), "EEE, d MMM yyyy")}</p>
              <button className="btn-gold" onClick={payBalance} data-testid="pay-balance-button"><Smartphone className="h-4 w-4" />{res.quote.currency === "KES" ? "Pay now with M-Pesa" : "Pay balance now"}</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
